<div *ngIf="!displayInline; else displayInlineTpl">
  <div>
    {{ address.address1 }}
    {{ address.address2 ? " " + address.address2 : "" }}
    {{ address.address3 ? " Int. " + address.address3 : "" }}
  </div>
  <div *ngIf="address.description">{{ address.description }}</div>
  <div *ngIf="address.neighborhood">{{ address.neighborhood }}</div>
  <div>{{ address.postalCode }}</div>
  <div>{{ address.city ? address.city + "," : "" }} {{ address.state }}</div>
  <div>{{ country }}</div>
</div>

<ng-template #displayInlineTpl>
  {{ inlineAddress }}
</ng-template>
